import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    Input,
    Select,
    Typography,
    Divider,
    DatePicker,
    Button,
    message,
    Pagination,
    Empty,
    Spin
} from "antd";
import {
    SearchOutlined,
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
    DashboardOutlined,
    ArrowRightOutlined,
    DollarOutlined,
    RightOutlined
} from "@ant-design/icons";
import moment from "moment";
import _commonService from "../../../modules/commonService";
import { useHistory } from "react-router-dom";
import StatusTag from "../../../components/StatusTag";
import _AdministratorService from "../../../modules/AdministratorService";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import { UnderReviewStatusId, LoanOfficerReviewStatusId } from "../../../constants/DataConstants";
import _consumerService from "../../../modules/consumerService";

const { Title, Text } = Typography;
const { Option } = Select;

// const PreApprovedWatermark = () => {
//     const watermarkColor = "rgba(66, 115, 111, 0.2)";

//     return (
//         <svg
//             width="200"
//             height="200"
//             viewBox="0 0 300 300"
//             style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%) rotate(-15deg)",
//                 opacity: 1,
//                 pointerEvents: "none",
//                 zIndex: 0,
//             }}
//         >
//             {/* Outer circle */}
//             <circle
//                 cx="150"
//                 cy="150"
//                 r="120"
//                 fill="none"
//                 stroke={watermarkColor}
//                 strokeWidth="10"
//                 strokeDasharray="6,6"
//             />

//             {/* Inner circle */}
//             <circle
//                 cx="150"
//                 cy="150"
//                 r="95"
//                 fill="none"
//                 stroke={watermarkColor}
//                 strokeWidth="6"
//             />

//             {/* Stars */}
//             {[...Array(6)].map((_, i) => {
//                 const angle = (i * 360) / 6;
//                 const x = 150 + 80 * Math.cos((angle * Math.PI) / 180);
//                 const y = 150 + 80 * Math.sin((angle * Math.PI) / 180);
//                 return (
//                     <text
//                         key={i}
//                         x={x}
//                         y={y}
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                         fontSize="16"
//                         fill={watermarkColor}
//                     >
//                         ★
//                     </text>
//                 );
//             })}

//             {/* Ribbon */}
//             <rect
//                 x="25"
//                 y="125"
//                 width="250"
//                 height="50"
//                 fill={watermarkColor} // optional, can keep original red if you want
//                 rx="6"
//             />

//             {/* Ribbon text */}
//             <text
//                 x="150"
//                 y="158"
//                 textAnchor="middle"
//                 fontSize="28"
//                 fontWeight="700"
//                 fill={"#555"} // optional, makes text match watermark color
//                 letterSpacing="2"
//             >
//                 PRE-QUALIFY
//             </text>
//         </svg>
//     );
// };


//export default PreApprovedWatermark;

const PreApprovedWatermark = () => {
    const watermarkColor = "rgba(255, 255, 255, 0.12)";

    return (
        <div className="watermark-container" style={{
            position: "absolute",
            top: "50%",
            left: "18%", // Keep it pinned to the left
            transform: "translateY(-50%) rotate(-12deg)",
            pointerEvents: "none",
            zIndex: 0,
            // RESPONSIVE WIDTH LOGIC:
            width: "var(--stamp-width, 40%)",
            maxWidth: "350px",
            minWidth: "180px"
        }}>
            <style>{`
                @media (max-width: 768px) {
                    .watermark-container {
                        left: 6% !important;
                        width: 40% !important;
                    }
                }
                @media (max-width: 480px) {
                    .watermark-container {
                        width: 50% !important;
                        top: 40% !important;
                    }
                }
            `}</style>

            <svg
                viewBox="0 0 400 200"
                width="100%"
                height="auto"
                preserveAspectRatio="xMinYMid meet"
            >
                <defs>
                    <filter id="grunge">
                        <feTurbulence type="fractalNoise" baseFrequency="0.15" numOctaves="3" result="noise" />
                        <feDisplacementMap in="SourceGraphic" in2="noise" scale="4" />
                    </filter>
                </defs>

                <g filter="url(#grunge)">
                    <rect
                        x="10"
                        y="30"
                        width="380"
                        height="140"
                        rx="25"
                        fill="none"
                        stroke={watermarkColor}
                        strokeWidth="10"
                    />
                    <text
                        x="50%"
                        y="50%"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontSize="36"
                        fontWeight="900"
                        fontFamily="Arial Black, sans-serif"
                        fill={watermarkColor}
                        letterSpacing="2"
                        style={{
                            transform: "scale(0.9, 2.5)", // Massive vertical height increase
                            transformOrigin: "center",
                        }}
                    >
                        PRE-QUALIFIED
                    </text>
                </g>
            </svg>
        </div>
    );
};


const ApplicationList = ({
    allApplications = [],
    searchTerm,
    applicationStatusForFilter,
    sortBy,
    fromDate, // [moment, moment]
    toDate,
    onSearchChange,
    fromDateChange,
    toDateChange,
    onSortChange,
    onApplicationStatusChange,
    onClearFilters,
    pageIndex,
    pageSize,
    totalCount,
    onPaginationChange,
    isFromLoanOfficerDashboard
}) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const bankerIdRaw = localStorage.getItem("administratorUserId");
    const bankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;

    const LoanOfficerId = localStorage.getItem("capitalProviderUserId");
    const loanOfficerID = LoanOfficerId ? parseInt(LoanOfficerId) : null;
    const [applicationStatusData, setApplicationStatusData] = useState([]);

    const handleClickUpdateApplicantStatus = async (item) => {
        if (!isFromLoanOfficerDashboard && item?.Application_Status_Id == 4) {
            history.push(`/loanapplication-details-for-administrator/${item.Id}`);
            return;
        }

        if (item &&
            item.Application_Status_Id && ![5, 6, 7, 8, 9, 10].includes(item.Application_Status_Id)) {
            let reqObj = {
                Id: item.Id,
                ApplicationId: item.ApplicationId,
                Application_Status_Id: isFromLoanOfficerDashboard ? LoanOfficerReviewStatusId : UnderReviewStatusId,
                BankerId: isFromLoanOfficerDashboard ? null : bankerId,
                LoanOfficerId: isFromLoanOfficerDashboard ? loanOfficerID : null
            }
            setLoading(true);
            try {
                const res = await _AdministratorService.updateApplicantStatus(reqObj);
                if (res.data.IsSuccess) {
                    setLoading(false);
                    history.push(`/loanapplication-details-for-administrator/${item.Id}`);
                } else {
                    setLoading(false);
                    message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
                }
            } catch (err) {
                setLoading(false);
                console.log(err);
            }
            finally {
                setLoading(false);
            }
        } else {
            history.push(`/loanapplication-details-for-administrator/${item.Id}`);
        }
    }

    useEffect(() => {
        getApplicationStatus();
    }, []);

    const getApplicationStatus = async () => {
        try {
            const res = await _consumerService.getAllDropdownDataByName(isFromLoanOfficerDashboard ? "applicationstatusloanofficer" : "applicationstatus");
            if (res.data) {
                setApplicationStatusData(res.data);
            }
        } catch (e) {
            console.log(e);

        }
    };

    // const currentMonthYear = _commonService.getCurrentMonthAndYear();

    return (
        <Spin spinning={loading}>
            <div className="application-list-container">
                {/* Filters */}
                {/* <Title style={{ marginBottom: 15 }} level={5}>Monthly Review, {currentMonthYear}</Title> */}
                <Row gutter={[0, 32]} >
                    <Col span={24}>
                        <Row gutter={[16, 16]} className="fitlers">
                            {/* <Col xs={24} sm={12} md={5} lg={5}>
                                <Input
                                    value={searchTerm}
                                    onChange={(e) => onSearchChange?.(e.target.value)}
                                    placeholder="Search Application"
                                    prefix={<SearchOutlined />}
                                    className="filterInput cardViewMain"

                                />
                            </Col> */}

                            <Col xs={24} sm={12} md={5} lg={5}>
                                <Input
                                    value={searchTerm}
                                    onChange={(e) => onSearchChange?.(e.target.value)}
                                    onPressEnter={(e) => {
                                        e.preventDefault();     // ✅ stops form submit
                                    }}
                                    placeholder="Search Application"
                                    prefix={<SearchOutlined />}
                                    className="filterInput cardViewMain"
                                />
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={5}>
                                <Select
                                    // allowClear
                                    className="cardViewMain"
                                    dropdownClassName="cardViewMainDropdown"

                                    value={applicationStatusForFilter}
                                    onChange={(value) => onApplicationStatusChange?.(value)}
                                    placeholder="Application Status"
                                    style={{ width: "100%" }}
                                >
                                    {applicationStatusData && applicationStatusData.map((obj) => (
                                        <Option key={obj.Id} value={obj.Id}>
                                            {obj.Name}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={3}>
                                {/* <Text style={{ marginRight: 8 }}>From:</Text> */}
                                <DatePicker
                                    style={{ width: "100%" }}
                                    allowClear
                                    value={fromDate}
                                    onChange={fromDateChange}
                                    placeholder="From Date"
                                    format="MM/DD/YYYY"
                                    className="cardViewMain"
                                    popupClassName="cardViewMainDatePicker"

                                />
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={3}>
                                {/* <Text style={{ marginRight: 8 }}>To:</Text> */}
                                <DatePicker
                                    style={{ width: "100%" }}
                                    allowClear
                                    value={toDate}
                                    onChange={toDateChange}
                                    placeholder="To Date"
                                    format="MM/DD/YYYY"
                                    className="cardViewMain"
                                    popupClassName="cardViewMainDatePicker"

                                />
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={5}>
                                <Select
                                    allowClear
                                    className="cardViewMain"
                                    dropdownClassName="cardViewMainDropdown"

                                    value={sortBy}
                                    onChange={onSortChange}
                                    placeholder="Sort By"
                                    style={{ width: "100%" }}
                                    options={[
                                        { label: "Newest First", value: "newest" },
                                        { label: "Oldest First", value: "oldest" },
                                        { label: "High to Low", value: "high" },
                                        { label: "Low to High", value: "low" },
                                    ]}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={3} lg={3}>
                                <Button
                                    type="default"
                                    onClick={onClearFilters}
                                    style={{ width: "100%" }}
                                    className="clear-btn"
                                    disabled={searchTerm === "" && !applicationStatusForFilter && !fromDate && !toDate && !sortBy}
                                >
                                    Clear Filters
                                </Button>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={24} className="title-container">


                        <Title level={3}>
                            All Applications
                        </Title>
                    </Col>
                    <Col span={24}>


                        {/* Application Cards */}
                        <Row gutter={[16, 16]} className="applications-container">
                            {allApplications && allApplications.map((item, index) => (
                                <Col key={index} xs={24} md={24}>
                                    <Card className="cardViewMain">


                                        {/* {item.IsPreQualify === true && <PreApprovedWatermark />} */}

                                        <Row gutter={[16, 16]} justify="space-between">
                                            {/* Left Section */}
                                            <Col span={24} className="application-number-box">
                                                <div style={{ float: "right" }}>
                                                    {item.IsPreQualify === true && <StatusTag statusId={13} />}
                                                </div>
                                                <div style={{ display: "flex" }}>
                                                    <Text type="secondary" className="appliction-number">Application {item.ApplicationId}</Text>
                                                    <StatusTag statusId={item.Application_Status_Id} />
                                                </div>

                                                <div>
                                                    <Text type="secondary" className="submitted-date">Submitted: {moment(item.CreatedDate).format("MM/DD/YYYY")}</Text>
                                                </div>
                                            </Col>
                                            <Col span={24}>
                                                <Row>
                                                    <Col md={10} xs={24}>
                                                        <Title level={5} className="title" style={{ marginBottom: '10px' }}><UserOutlined style={{ marginRight: 8 }} /> Applicant Information</Title>
                                                        <Text className="sub-title">
                                                            {item.FirstName} {item.MiddleName} {item.LastName}<span className="dash">|</span>
                                                            Type {item.ApplicantType}
                                                        </Text>
                                                        <div style={{
                                                            display: "grid",
                                                            gap: "10px",
                                                            marginTop: "10px"
                                                        }}>
                                                            <Text className="sub-text"> <PhoneOutlined className="info-icon" /> {item.Phone ? _commonService.formatUSPhoneNumber(item.Phone) : "N/A"} </Text>
                                                            <Text className="sub-text"> <MailOutlined className="info-icon" /> {item.Email} </Text>
                                                            <Text className="sub-text"> <EnvironmentOutlined className="info-icon" /> {item.City || "N/A"}, {item.State || "N/A"}, {item.Zip || "N/A"} </Text>
                                                        </div>
                                                    </Col>

                                                    <Col md={12} xs={24}>
                                                        <Title level={5} className="title">
                                                            <span className="dollar-icon">$</span> Financial Snapshot</Title>
                                                        <Row gutter={16} className="financial-snapshot">
                                                            <Col span={20}>
                                                                <Text className="sub-title">Amount Requested:</Text>
                                                                <Title level={5} className="sub-text" style={{ marginTop: '0px' }}>{item.Cons_ApproximateLoanSize ? `$ ${_commonService.formatNumberWithCommas(item.Cons_ApproximateLoanSize)}` : "N/A"}</Title>
                                                            </Col>
                                                            <Col span={20}>
                                                                <Text type="secondary" className="sub-title">Credit Score</Text>
                                                                <Text className={item.CBRScore < item.FixCBRScore ? "sub-text redColor" : " sub-text"} strong>{item.CBRScore}</Text>
                                                            </Col>
                                                            <Col span={20}>
                                                                <Text type="secondary" className="sub-title">TDSR</Text>
                                                                <Text className={parseFloat(item.PFTDSR) > parseFloat(item.FixTDSR) ? "sub-text redColor" : "sub-text"} strong>{item.PFTDSR ? item.PFTDSR + "%" : "N/A"}</Text>
                                                            </Col>
                                                            <Col span={20}>
                                                                <Text type="secondary" className="sub-title">Leverage</Text>
                                                                <Text strong className={item.Levrage > item.FixLevrage ? "sub-text redColor" : "sub-text"} >{item.Levrage || "N/A"}</Text>

                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={2} xs={24}>
                                                        <Button
                                                            type="link"
                                                            className="fRight viewBtn"
                                                            onClick={() => { handleClickUpdateApplicantStatus(item) }}
                                                        >
                                                            <span>View Application</span><RightOutlined style={{ fontSize: 'inherit', marginTop: "4px" }} />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                    </Col>
                    <Col span={24}>
                        {allApplications.length === 0 && (
                            <div style={{ textAlign: "center", marginTop: 20 }}>
                                <Empty
                                    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                                    styles={{ image: { height: 60 } }}
                                    description={
                                        <Typography.Text>
                                            No Applications found
                                        </Typography.Text>
                                    }
                                />
                            </div>
                        )}

                        {allApplications.length > 0 && (
                            <div className="pgDiv">
                                <Pagination
                                    showSizeChanger
                                    current={pageIndex}
                                    pageSize={pageSize}
                                    total={totalCount}
                                    onChange={onPaginationChange}
                                    className={allApplications && allApplications.length < 1 ? "hide" : "fRight"}
                                />
                            </div>
                        )}

                    </Col>
                </Row>
            </div>
        </Spin>
    );
}


export default ApplicationList;